var map = {
	"./finance.js": "ccX1"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "nHpy";


//////////////////
// WEBPACK FOOTER
// ./src/router/finance nonrecursive ^(?!\.\/index|\.\/cockpit).*\.js$
// module id = nHpy
// module chunks = 225